import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: "2.4rem"
    },
    rootScroll: {
      overflowX: "auto",
      width: "100%",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableCell-head": {
        background: "#D4F4F8CC",
        padding: "2.8rem 1.2rem"
      }
    },
    container: {
      paddingBottom: "9rem"
    },
    rowCheckBox: {
      display: "flex"
    },
    itemCenter: {
      alignSelf: "center"
    },
    paginationBottom: {
      marginTop: "2.4rem"
    },
    headerGardient: {
      fontWeight: 400,
      marginLeft: "4px",
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    },
    checkbox: {
      height: "fit-content",
      margin: "2.4rem",
      marginLeft: "4px"
    },
    wrapper: {
      maxHeight: 720,
      height: "100%",
      background: theme.palette.background.default,
      padding: "2.4rem 4rem 0rem 4rem",
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)",
      borderTopLeftRadius: 32,
      borderTopRightRadius: 32,
      color: theme.palette.grey[900]
    },
    titleWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    headerClose: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& img": {
        marginLeft: 12,
        cursor: "pointer"
      }
    },
    titleModal: {
      color: theme.palette.info.dark
    },
    divider: {
      backgroundColor: "#009FB8 !important"
    },
    disabledBtn: {
      opacity: 0.1
    },
    btnConfirm: {
      width: 200,
      height: 40
    },
    tableWrapper: {
      overflowY: "auto",
      marginBottom: "10rem",
      "&::-webkit-scrollbar": {
        height: "14px"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    }
  }),
  { name: "AtpCtpList" }
);

export default useStyles;
